/**
 * Runtime configuration for a deployed web build.
 *
 * The production image is built once and promoted unchanged from development to staging to
 * production, so nothing environment-specific can be inlined at build time. Instead index.html
 * carries `<meta name="talon-config" content="__TALON_CONFIG__">`, and the container fills it in at
 * startup with base64-encoded JSON of these values (apps/web/deploy/40-talon-config.sh).
 *
 * Locally (`yarn start`, Vitest) the placeholder is left as-is, and callers fall back to the
 * build-time process.env values.
 */
export type TRuntimeConfig = Partial<{
  NODE_ENV: string;
  API_HOST: string;
  API_PORT: string;
  API_BASE: string;
  API_VERSION: string;
  CLIENT_URL: string;
  POSTHOG_KEY: string;
  POSTHOG_HOST: string;
  /** Git SHA of the deployed build */
  RELEASE: string;
}>;

export const CONFIG_META_NAME = 'talon-config';
export const CONFIG_PLACEHOLDER = '__TALON_CONFIG__';

type TMetaSource = Pick<Document, 'querySelector'>;

export const readRuntimeConfig = (doc: TMetaSource | undefined = globalThis.document): TRuntimeConfig => {
  const content = doc?.querySelector(`meta[name="${CONFIG_META_NAME}"]`)?.getAttribute('content');
  if (!content || content === CONFIG_PLACEHOLDER) return {};
  try {
    return JSON.parse(atob(content)) as TRuntimeConfig;
  } catch {
    console.error('Ignoring malformed runtime config in <meta name="talon-config">');
    return {};
  }
};

export const runtimeConfig = readRuntimeConfig();
